export enum SECTION_PLAN_SUMMARY_TEST_ID {
  section = 'section-plan-summary',
  commonFeatures = 'COMMON_FEATURES_TEST_ID',
  accordion = 'section-plan-summary--accordion',
  footerContent = 'plan-summary--footer-content',
  carousel = 'section-plan-summary--carousel'
}
